/** Build the public pagination URL without serializing empty filters. */
export function buildArticlesUrl(offset: number, limit: number, activeCategory?: string, activeIndustry?: string) {
  const params = new URLSearchParams({
    offset: String(offset),
    limit: String(limit)
  });
  if (activeCategory) {
    params.set("articleCategory", activeCategory);
  }
  if (activeIndustry) {
    params.set("industryCategory", activeIndustry);
  }
  return `/api/get-articles?${params.toString()}`;
}